import { defineWebModule } from "../../web/module";

export default defineWebModule({
  id: "core",
});
